import { render } from "./ViewsSurveyCustomer.vue?vue&type=template&id=cd20106c"
import script from "./ViewsSurveyCustomer.vue?vue&type=script&lang=js"
export * from "./ViewsSurveyCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__